import { ConfigProvider } from 'antd';
import { getListVaiTro, getUserInfo, setInitUrl } from 'appRedux/actions/Auth';
import { onLayoutTypeChange, onNavStyleChange, setThemeType } from 'appRedux/actions/Setting';
import AppLocale from 'lngProvider';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import {
  LAYOUT_TYPE_BOXED,
  LAYOUT_TYPE_FRAMED,
  LAYOUT_TYPE_FULL,
  NAV_STYLE_ABOVE_HEADER,
  NAV_STYLE_BELOW_HEADER,
  NAV_STYLE_DARK_HORIZONTAL,
  NAV_STYLE_DEFAULT_HORIZONTAL,
  NAV_STYLE_INSIDE_HEADER_HORIZONTAL,
  THEME_TYPE_DARK
} from 'src/constants/ThemeSetting';
import { getCookieValue } from 'src/util/Common';
import URLSearchParams from 'url-search-params';
import Forbidden from '../Forbidden';
import SignIn from '../SignIn';
import SignUp from '../SignUp';
import MainApp from './MainApp';

const RestrictedRoute = ({ component: Component, token, ...rest }) => (
  <Route
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...rest}
    render={(props) => (token
      // eslint-disable-next-line react/jsx-props-no-spreading
      ? <Component {...props} />
      : (
        <Redirect
          to={{
            pathname: '/dang-nhap',
            state: { from: props.location }
          }}
        />
      ))}
  />
);

RestrictedRoute.propTypes = {
  component: PropTypes.func.isRequired,
  location: PropTypes.objectOf(PropTypes.any),
  token: PropTypes.string
};

RestrictedRoute.defaultProps = {
  location: undefined,
  token: undefined
};

// eslint-disable-next-line react/no-multi-comp
class App extends Component {
  componentDidMount() {
    localStorage.removeItem('dataFilter');
    if (this.props.initURL === '') {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
    const params = new URLSearchParams(this.props.location.search);
    if (params.has('theme')) {
      this.props.setThemeType(params.get('theme'));
    }
    if (params.has('nav-style')) {
      this.props.onNavStyleChange(params.get('nav-style'));
    }
    if (params.has('layout-type')) {
      this.props.onLayoutTypeChange(params.get('layout-type'));
    }
  }

  async componentDidUpdate() {
    const {
      vaiTro, getListVaiTro, getUserInfo, authUser
    } = this.props;
    const accessToken = await getCookieValue('accessTokenBDT');
    if (accessToken) {
      if (isEmpty(vaiTro)) await getListVaiTro();
      if (isEmpty(authUser)) await getUserInfo();
    }
  }

  setLayoutType = (layoutType) => {
    if (layoutType === LAYOUT_TYPE_FULL) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('full-layout');
    } else if (layoutType === LAYOUT_TYPE_BOXED) {
      document.body.classList.remove('full-layout');
      document.body.classList.remove('framed-layout');
      document.body.classList.add('boxed-layout');
    } else if (layoutType === LAYOUT_TYPE_FRAMED) {
      document.body.classList.remove('boxed-layout');
      document.body.classList.remove('full-layout');
      document.body.classList.add('framed-layout');
    }
  };

  setNavStyle = (navStyle) => {
    if (navStyle === NAV_STYLE_DEFAULT_HORIZONTAL
      || navStyle === NAV_STYLE_DARK_HORIZONTAL
      || navStyle === NAV_STYLE_INSIDE_HEADER_HORIZONTAL
      || navStyle === NAV_STYLE_ABOVE_HEADER
      || navStyle === NAV_STYLE_BELOW_HEADER) {
      document.body.classList.add('full-scroll');
      document.body.classList.add('horizontal-layout');
    } else {
      document.body.classList.remove('full-scroll');
      document.body.classList.remove('horizontal-layout');
    }
  };

  render() {
    const {
      match, location, themeType, layoutType, navStyle, locale, token, initURL
    } = this.props;
    if (themeType === THEME_TYPE_DARK) {
      document.body.classList.add('dark-theme');
    }
    const accessToken = token || getCookieValue('accessTokenBDT');
    if (location.pathname === '/') {
      if (accessToken === null) {
        return (<Redirect to="/dang-nhap" />);
      } if (initURL === '' || initURL === '/' || initURL === '/dang-nhap') {
        return (
          <Redirect to={getCookieValue('defaultUrl')
            ? getCookieValue('defaultUrl')
            : '/danh-muc/nhap-lieu'}
          />
        );
      }
      return (<Redirect to={initURL} />);
    }
    this.setLayoutType(layoutType);
    this.setNavStyle(navStyle);
    const currentAppLocale = AppLocale[locale.locale];
    return (
      <ConfigProvider locale={currentAppLocale.antd}>
        <IntlProvider
          locale={currentAppLocale.locale}
          messages={currentAppLocale.messages}
        >
          <Switch>
            <Route component={SignIn} exact path="/dang-nhap" />
            <Route component={Forbidden} exact path="/Forbidden" />
            <Route component={SignUp} exact path="/signup" />
            <RestrictedRoute component={MainApp} path={`${match.url}`} token={accessToken} />
          </Switch>
        </IntlProvider>
      </ConfigProvider>
    );
  }
}

App.propTypes = {
  initURL: PropTypes.string.isRequired,
  setInitUrl: PropTypes.func.isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  setThemeType: PropTypes.func.isRequired,
  onNavStyleChange: PropTypes.func.isRequired,
  onLayoutTypeChange: PropTypes.func.isRequired,
  getListVaiTro: PropTypes.func.isRequired,
  getUserInfo: PropTypes.func.isRequired,
  vaiTro: PropTypes.any.isRequired,
  match: PropTypes.objectOf(PropTypes.any).isRequired,
  authUser: PropTypes.objectOf(PropTypes.any).isRequired,
  themeType: PropTypes.string.isRequired,
  layoutType: PropTypes.string.isRequired,
  token: PropTypes.string.isRequired,
  navStyle: PropTypes.string.isRequired,
  locale: PropTypes.objectOf(PropTypes.any).isRequired
};

const mapStateToProps = ({ settings, auth }) => {
  const {
    locale, navStyle, themeType, layoutType
  } = settings;
  const {
    token, initURL, vaiTro, authUser
  } = auth;
  return {
    locale, token, navStyle, themeType, layoutType, initURL, vaiTro, authUser
  };
};
export default connect(mapStateToProps, {
  setInitUrl, setThemeType, onNavStyleChange, onLayoutTypeChange, getUserInfo, getListVaiTro
})(App);
